import { useState } from "react";
import {
  login,
  logout,
  register,
  verify,
  update,
  changePass,
  resetPass,
} from "../services/authService";

import { useLocalStorage } from "./useLocalStorage";

export const useLogin = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { setItem, removeItem } = useLocalStorage();

  const signin = async (username, password, email) => {
    setIsLoading(true);
    setError(false);
    let response = "Something went wrong, Please try again later!";
    try {
      response = await login(username, password);
      setIsLoading(false);
      if (response === "success") {
        setItem("uname", username);
        localStorage.setItem("username", username);
        localStorage.setItem("email", email);

        setItem("isLogin", true);
        return "success";
      } else {
        setError(true);
        return "Invalid credentials. Please try again.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong";
    }
  };

  const signup = async (username, email, password) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await register(username, email, password);
      setIsLoading(false);
      if (response === "success") {
        setItem("isLogin", true);
        return "success";
      } else {
        setError(true);
        setItem("isLogin", false);
        return response;
      }
    } catch (error) {
      setError(true);
      setIsLoading(false);
      setItem("isLogin", false);

      return "An error occured while registering.";
    }
  };

  const signout = async () => {
    try {
      await logout();
      removeItem("uname");
      setIsLoading(false);
      removeItem("isLogin");
    } catch (error) {
      return "An error occured while logging out.";
    }
  };

  const verifyCode = async (email, code) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await verify(email, code);
      setIsLoading(false);
      if (response === "success") {
        setItem("isVerified", true); // Optionally store verification status
        return "success";
      } else {
        setError(true);
        setItem("isVerified", false);
        return "Invalid code. Please try again.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      setItem("isVerified", false);
      return "An error occurred while verifying the code.";
    }
  };

  //update password
  const updatePassword = async (oldPassword, newPassword) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await update(oldPassword, newPassword);
      setIsLoading(false);
      if (response === "success") {
        return "Password Updated";
      } else {
        setError(true);
        return response;
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return error;
    }
  };

  // reset password
  const resetPassword = async (email) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await resetPass(email);
      setIsLoading(false);
      if (response === "success") {
        return "success";
      } else {
        setError(true);
        return response;
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return error;
    }
  };

  const changePassword = async (token, newPassword) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await changePass(token, newPassword);
      setIsLoading(false);
      if (response === "success") {
        return "success";
      } else {
        setError(true);
        return response;
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return error;
    }
  };

  return {
    signin,
    signup,
    signout,
    verifyCode,
    updatePassword,
    resetPassword,
    changePassword,
    isLoading,
    error,
  };
};
